




















































import { Component, Mixins } from "vue-property-decorator";
import { FormatReference, WriteMethodTypeValue } from "../../../domain/format";
import { SelectorDialogMixin } from "../../system/dialogs/mixins";
import { ISingleSelectableAsynchronously, ISingleSelectableConditionallyAsynchronously } from "../../system/selectors";
import FormatListViewer from "../viewers/FormatListViewer.vue";
import { IRestriction } from "../../system";
import { IFormatListSelectorDialogAddCondition, instanceOfIFormatListSelectorDialogAddCondition } from "./IFormatListSelectorDialogAddCondition";

@Component({
  components: {
    FormatListViewer,
  },
})
export default class FormatListSelectorDialog extends Mixins(SelectorDialogMixin) implements ISingleSelectableAsynchronously<FormatReference>, ISingleSelectableConditionallyAsynchronously<FormatReference, IFormatListSelectorDialogAddCondition> {
  data() {
    return {
      tabRestrictions: null as { [key: string]: IRestriction },
      firstSelectedFormat: null as FormatReference,
      name: this.formatNameWording,
      containsExpired: false,
      containsDeleted: false,
      shouldIgnoreChained: false,
      defaultWriteMethodTypes: null as WriteMethodTypeValue[],
    };
  }
  tabRestrictions: { [key: string]: IRestriction };
  firstSelectedFormat: FormatReference;
  name: string;
  containsExpired: boolean;
  containsDeleted: boolean;
  shouldIgnoreChained: boolean;
  defaultWriteMethodTypes: WriteMethodTypeValue[];

  get visibleTabs(): any[] {
    const visibleTabs: any[] = [];
    for (const tab of FormatListViewer.formatTabs) {
      const restriction = this.getRestriction(tab.keyword);
      if (restriction && restriction.isDisabled) { continue; }
      visibleTabs.push(tab);
    }
    return visibleTabs;
  }

  private getRestriction(keyword: string): IRestriction {
    if (!this.tabRestrictions || !keyword) { return null; }
    return this.tabRestrictions[keyword];
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  async selectOption(defaultOption?: FormatReference, restrictions?: { [key: string]: IRestriction }): Promise<FormatReference> {
    this.tabRestrictions = restrictions;
    // フォーマットツリーが未取得の場合はshow()で渡した値はツリー取得完了のタイミングでクリアされてしまう。
    // すでにツリー取得済みの場合は反映される。
    // FormatListViewerのformatIdに値を渡すとツリー未取得の場合でも反映されるようになるが、
    // formatIdの値を変えると内部のリアクティブが動作して2回目以降の表示タイミングで選択がクリアされてしまう。
    // 対策として不要なリアクティブをキックしない別Propを追加している。
    this.firstSelectedFormat = defaultOption;
    return this.show<FormatReference>(defaultOption);
  }

  async selectOptionConditionally(condition: IFormatListSelectorDialogAddCondition, defaultOption?: FormatReference, restrictions?: { [key: string]: IRestriction }): Promise<FormatReference> {
    this.tabRestrictions = restrictions;
    // フォーマットツリーが未取得の場合はshow()で渡した値はツリー取得完了のタイミングでクリアされてしまう。
    // すでにツリー取得済みの場合は反映される。
    // FormatListViewerのformatIdに値を渡すとツリー未取得の場合でも反映されるようになるが、
    // formatIdの値を変えると内部のリアクティブが動作して2回目以降の表示タイミングで選択がクリアされてしまう。
    // 対策として不要なリアクティブをキックしない別Propを追加している。
    this.firstSelectedFormat = defaultOption;
    if (instanceOfIFormatListSelectorDialogAddCondition(condition)) {
      this.name = condition.name ? condition.name : this.formatNameWording;
      this.containsExpired = condition.containsExpired;
      this.containsDeleted = condition.containsDeleted;
      this.shouldIgnoreChained = condition.shouldIgnoreChained;
      this.defaultWriteMethodTypes = condition.defaultWriteMethodTypes ? condition.defaultWriteMethodTypes : [];
      this.validate = condition.validate;
    }
    return this.show<FormatReference>(defaultOption);
  }
}
